/** Player-facing data credits (vocab-v2 §2). Mirrors THIRD_PARTY_NOTICES.md at the repo root. */
export interface ThirdPartyCredit {
  name: string;
  licence: string;
  use: string;
}

export const THIRD_PARTY_CREDITS: readonly ThirdPartyCredit[] = [
  {
    name: "FineWeb-Edu (Hugging Face)",
    licence: "ODC-BY 1.0",
    use: "word frequencies",
  },
  {
    name: "ConceptNet 5.7",
    licence: "CC BY-SA 4.0",
    use: "word-graph selection and repair",
  },
  {
    name: "Wikipedia (via Common Pile)",
    licence: "CC BY-SA 4.0",
    use: "co-occurrence training text",
  },
  { name: "MorphyNet", licence: "CC BY-SA 3.0", use: "inflection collapse" },
  {
    name: "Princeton WordNet 3.0",
    licence: "WordNet 3.0 License",
    use: "word definitions",
  },
  {
    name: "better-profanity",
    licence: "MIT",
    use: "content-safety filtering",
  },
  { name: "AFINN", licence: "Apache-2.0", use: "sensitive-edge guarding" },
  {
    name: "typesafe-sdk-js types",
    licence: "MIT",
    use: "System One contract types (Ariadne)",
  },
];
